import React from "react";
import {IconProps} from './index.tsx';
// import profileImg from "shared/assets/img/user.png";  // <-- правильный импорт
import profileImg from "shared/assets/img/user.png";  // <-- правильный импорт

export const Profile: React.FC<IconProps & {imgSrc: string}> = ({
                                                 width = 24,
                                                 height = 24,
                                                 className,
                                                 imgSrc
                                             }) => {
  return (
        <img
            src={imgSrc || profileImg}
            alt="Profile"
            width={width}
            height={height}
            className={className}
            style={{borderRadius: '50%'}}
        />
    );
};
